"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeCard = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var detail_card_1 = require("../detail-card");
var employee_profile_1 = require("../employee-profile");
function EmployeeCard(_a) {
    var employeeDefinition = _a.employeeDefinition, selectableOptions = _a.selectableOptions, actions = _a.actions, isExpandable = _a.isExpandable, defaultExpanded = _a.defaultExpanded, cardProps = _a.cardProps;
    var name = employeeDefinition.name, title = employeeDefinition.title, image = employeeDefinition.image;
    return (react_1.default.createElement(detail_card_1.DetailCard, { title: title, isExpandable: isExpandable, defaultExpanded: defaultExpanded, selectableOptions: selectableOptions, isHighlighted: selectableOptions ? selectableOptions.isSelected : false, actions: actions, cardProps: cardProps },
        react_1.default.createElement(employee_profile_1.EmployeeProfile, { name: name, imageUrl: image, variant: "small" })));
}
exports.EmployeeCard = EmployeeCard;
//# sourceMappingURL=index.js.map